import {useCallback} from "react";
import {createOrganManagerAsync} from "../../../store/organManagerSlice";
import {useAppDispatch} from "../../../hooks/hooks";
import {OrganManagerPostDTO} from "../../../types/organManager";

export function useOrganManagerCreator() {
    const dispatch = useAppDispatch();

    const createOrganManager = useCallback(
        async ({ nationality, email, codePhone, phoneNumber, name, password,
                   adminOrganManagerPermissionPostDTO, organManagerType }
                   : OrganManagerPostDTO) => {
            try {
                await dispatch(
                    createOrganManagerAsync({
                        nationality, email, codePhone, phoneNumber, name, password,
                        adminOrganManagerPermissionPostDTO, organManagerType
                    })
                ).unwrap();
            } catch (e) {
                console.error(e);
                alert("일시적인 문제가 발생했습니다.\n잠시 후 다시 시도해주세요.")
                throw new Error("소속관리자 등록 에러");
            }
        },
        [dispatch]
    );
    return {
        createOrganManager
    }
}